import { render, staticRenderFns } from "./GoodLabel.vue?vue&type=template&id=593f704a&scoped=true&"
import script from "./GoodLabel.vue?vue&type=script&lang=js&"
export * from "./GoodLabel.vue?vue&type=script&lang=js&"
import style0 from "./GoodLabel.vue?vue&type=style&index=0&id=593f704a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f704a",
  null
  
)

export default component.exports